import type {ContentSubmissionApprovalStatus} from '@/types/contentSubmission';
import {getApprovalStepDisplayName} from '@/views/campaigns/constants/approvalSteps';

export type ApprovalBreakdown = {
  requiredStepsNames: string[];
  approvedStepsNames: string[];
  approvedStepsEntries: ContentSubmissionApprovalStatus[];
  pendingStepsNames: string[];
  pendingDepartments: string[];
};

export function getApprovalBreakdown(
  approvalStatus?: ContentSubmissionApprovalStatus[]
): ApprovalBreakdown {
  const entries = approvalStatus ?? [];
  const approvedStepsEntries = entries.filter((a) => a.approved);
  const pendingStepsEntries = entries.filter((a) => !a.approved);
  const requiredStepsNames = entries.map((a) => a.step);
  const approvedStepsNames = approvedStepsEntries.map((a) => a.step);
  const pendingStepsNames = pendingStepsEntries.map((a) => a.step);
  const pendingDepartments = pendingStepsNames.map(getApprovalStepDisplayName);
  return {
    requiredStepsNames,
    approvedStepsNames,
    approvedStepsEntries,
    pendingStepsNames,
    pendingDepartments,
  };
}
